<div
  class="textarea-wrapper"
  [class.error]="isInvalid"
  [class.ta-has-max-rows]="maxRows !== null"
  [class.textarea-wrapper-has-value]="control.value?.length > 0"
  [style.--ta-max-rows]="maxRows"
  [style.--ta-rows]="rows"
>
  <div class="textarea-frame">
    <ion-textarea
      class="ta"
      (keyup.enter)="enterKey.emit()"
      [autoGrow]="autoGrow"
      [formControl]="control"
      [maxlength]="maxlength"
      [placeholder]="placeholder || label"
      [rows]="rows"
      autocapitalize="off"
      [spellcheck]="false"
      [counter]="false">
    </ion-textarea>
  </div>

  @if (counter) {
  <!-- 枠の外に出すカウンター（counter=true のときのみ表示） -->
  <div class="textarea-counter">
    {{ control.value?.length || 0 }}/{{ maxlength }}
  </div>
  }

  @if (isInvalid) {
    <div class="error-message">
      @for (message of errorMessages; track message) {
        <div>{{ message }}</div>
      }
    </div>
  }
</div>
